import { render, staticRenderFns } from "./trainingAgenda.vue?vue&type=template&id=30a6db2a&scoped=true"
import script from "./trainingAgenda.vue?vue&type=script&lang=js"
export * from "./trainingAgenda.vue?vue&type=script&lang=js"
import style0 from "./trainingAgenda.vue?vue&type=style&index=0&id=30a6db2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a6db2a",
  null
  
)

export default component.exports